import { render } from "./TermsOfService.vue?vue&type=template&id=63398e18"
const script = {}

import "./TermsOfService.vue?vue&type=style&index=0&id=63398e18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__